function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.947 5.053a1 1 0 000 1.414L12.48 15l-8.533 8.533a1 1 0 000 1.414l1.106 1.106a1 1 0 001.414 0L15 17.52l8.533 8.533a1 1 0 001.414 0l1.106-1.106a1 1 0 000-1.414L17.52 15l8.533-8.533a1 1 0 000-1.414l-1.106-1.106a1 1 0 00-1.414 0L15 12.48 6.467 3.947a1 1 0 00-1.414 0L3.947 5.053z",
  fill: "currentColor"
})));